import {
    SET_SIDE_NAV_OPEN,
    SideNavActionType
} from "../Types/SideNavActionTypes";

export interface ISideNavReducerState {
    open: boolean;
}

export const sideNavReducerState: ISideNavReducerState = {
    open: true,
};

export const sideNavReducer = (
    state: ISideNavReducerState = { ...sideNavReducerState },
    action: SideNavActionType
): ISideNavReducerState => {
    switch (action.type) {
        /** misc */
        case SET_SIDE_NAV_OPEN: {
            return {
                ...state,
                open: action.data,
            };
        }
        default: {
            return state;
        }
    }
};
